import { __awaiter, __generator, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import AbortablePromise from '../abortablePromise/AbortablePromise.js';
import StorageHandler from '../storageHandler/StorageHandler.js';
import AbortablePoller from './AbortablePoller.js';

var ResumablePoller = /** @class */ (function () {
    function ResumablePoller(pollKey, asyncFn, interval, timeout, inspect) {
        this.pollKey = pollKey;
        this.timeout = timeout;
        this.asyncFn = asyncFn;
        this.interval = interval;
        this.inspect = inspect;
    }
    ResumablePoller.create = function (pollKey, asyncFn, interval, timeout, inspect) {
        if (interval === void 0) { interval = 3000; }
        if (timeout === void 0) { timeout = 180000; }
        if (inspect === void 0) { inspect = function () { }; }
        // TODO we always set the timeout to 180000, this is not correct if we resume!
        return new ResumablePoller(pollKey, asyncFn, interval, timeout, inspect);
    };
    ResumablePoller.addResumeLogic = function (pollKey, promise) {
        return promise
            .then(function (t) {
            StorageHandler.removeItem(pollKey);
            return t;
        })
            .catch(function (e) {
            if (e instanceof Error && e.message !== 'Poller aborted') {
                StorageHandler.removeItem(pollKey);
            }
            throw e;
        });
    };
    ResumablePoller.prototype.setResumedPoller = function (started) {
        this.resumedPoller = started;
    };
    ResumablePoller.prototype.abort = function () {
        if (this.abortablePoller) {
            this.abortablePoller.abort();
        }
    };
    ResumablePoller.prototype.setPollParameters = function (parameters) {
        this.pollParameters = parameters;
        return this;
    };
    ResumablePoller.prototype.getPollParameters = function () {
        return this.pollParameters;
    };
    ResumablePoller.prototype.currentState = function () {
        if (this.abortablePoller) {
            return this.abortablePoller.currentState();
        }
        return 'NOT_STARTED'; // TODO or unknown?
    };
    ResumablePoller.prototype.onStateChange = function (callback) {
        this.stateCallback = callback;
        return this;
    };
    ResumablePoller.prototype.start = function () {
        return __awaiter(this, void 0, AbortablePromise, function () {
            var state, paramsWithTimestamp;
            return __generator(this, function (_a) {
                state = this.currentState();
                if (this.resumedPoller && state === 'STARTED') {
                    // if the poll was a restart we just return th poller started in the create function
                    return [2 /*return*/, this.resumedPoller];
                }
                paramsWithTimestamp = _assign(_assign({}, this.pollParameters), { timestamp: Date.now() + this.timeout });
                StorageHandler.setItem(this.pollKey, paramsWithTimestamp);
                this.abortablePoller = AbortablePoller.create(this.asyncFn, this.interval, this.timeout, this.inspect);
                if (this.stateCallback) {
                    this.abortablePoller.onStateChange(this.stateCallback);
                }
                return [2 /*return*/, ResumablePoller.addResumeLogic(this.pollKey, this.abortablePoller.setPollParameters(this.pollParameters).start())];
            });
        });
    };
    ResumablePoller.prototype.tryToResume = function () {
        var pollParameters = StorageHandler.getItem(this.pollKey);
        var isTimedOut = pollParameters && pollParameters.timestamp && Date.now() > pollParameters.timestamp;
        // if the poll has already being started in a previous session, restart it
        if (pollParameters && pollParameters.timestamp && !isTimedOut) {
            var adjustedTimeout = pollParameters.timestamp - Date.now();
            var parametersWithoutTimestamp = _assign({}, pollParameters);
            delete parametersWithoutTimestamp.timestamp;
            this.abortablePoller = AbortablePoller.create(this.asyncFn, this.interval, adjustedTimeout, this.inspect);
            if (this.stateCallback) {
                this.abortablePoller.onStateChange(this.stateCallback);
            }
            var resumedPoller = ResumablePoller.addResumeLogic(this.pollKey, this.abortablePoller.setPollParameters(parametersWithoutTimestamp).start());
            this.setPollParameters(parametersWithoutTimestamp);
            this.setResumedPoller(resumedPoller);
            if (this.stateCallback)
                this.stateCallback('RESUMED');
            return resumedPoller;
        }
        return undefined;
    };
    return ResumablePoller;
}());

export { ResumablePoller as default };
